// Logo.jsx — Symbole officiel AssoPerf (le "A" à flèche).
// variant="white" pour les fonds sombres, "color" (défaut) sinon.
export const Logo = ({ size = 32, variant = 'color', className = '' }) => (
  <img
    src={variant === 'white' ? '/brand/mark-white.png' : '/brand/mark.png'}
    alt="AssoPerf"
    className={className}
    style={{ height: size, width: 'auto', display: 'block' }}
    data-testid="brand-logo-mark"
  />
);
